export default __webpack_public_path__ + "static/media/logo.364e10db.png";